/** @format */

export interface Cta {
  link: string;
  linkTitle: string;
}
